export const maskEmail = (str) => {
    if (str.length <= 4) {
        return str.split('').map((v) => '＊').join('');
    }
    return str.substring(0, 4).split('').map((v) => '＊').join('') + str.substring(4);
};

export const maskMobile = (str) => {
    if (str.length <= 3) {
        return str;
    }
    return str.substring(0, 3) + str.substring(3, 8).split('').map((v) => '＊').join('') + str.substring(8);
};
